import { createContext, useReducer } from 'react'
import { ReactNode } from 'react'

import PropTypes from '@/lib/propTypes'

export interface LayoutState {
  contrastMode: boolean
  fontSize: 'md' | 'lg' | 'xl'
  accessibilityMode: boolean
  appData?: any
}

const defaultState: LayoutState = {
  contrastMode: false,
  fontSize: 'md',
  accessibilityMode: false,
  appData: undefined
}

export const LayoutContext = createContext<{
  state: LayoutState
  dispatch: React.Dispatch<{ type: string; payload: any }>
}>({
  state: defaultState,
  dispatch: () => null
})

export const LayoutReducer = (state: LayoutState, action: { type: string; payload: any }) => {
  switch (action.type) {
    case 'SET_CONTRAST_MODE':
      return { ...state, contrastMode: action.payload }
    case 'SET_FONT_SIZE':
      return { ...state, fontSize: action.payload }
    case 'SET_ACCESSIBILITY_MODE':
      return { ...state, accessibilityMode: action.payload }
    case 'SET_APP_DATA':
      return { ...state, appData: action.payload }
    case 'RESET_LAYOUT':
      return { ...defaultState, appData: state.appData }
    default:
      return state
  }
}

export const LayoutProvider = ({ children }: { children: ReactNode }) => {
  const [state, dispatch] = useReducer(LayoutReducer, defaultState)
  return <LayoutContext.Provider value={{ state, dispatch }}>{children}</LayoutContext.Provider>
}

LayoutProvider.propTypes = {
  children: PropTypes.node
}
